import { withInstall } from '/@/utils';

import appLogo from './src/AppLogo.vue';
import appProvider from './src/AppProvider.vue';
import appSearch from './src/search/AppSearch.vue';
import appLocalePicker from './src/AppLocalePicker.vue';
import appDarkModeToggle from './src/AppDarkModeToggle.vue';

export { useAppProviderContext } from './src/useAppContext';
let AppLogo: any = null;
if (appLogo) {
  AppLogo = appLogo ? withInstall(appLogo) : '';
}
let AppProvider: any = null;
if (appProvider) {
  AppProvider = appProvider ? withInstall(appProvider) : '';
}
let AppSearch: any = null;
if (appSearch) {
  AppSearch = appSearch ? withInstall(appSearch) : '';
}
let AppLocalePicker: any = null;
if (appLocalePicker) {
  AppLocalePicker = appLocalePicker ? withInstall(appLocalePicker) : '';
}
let AppDarkModeToggle: any = null;
if (appDarkModeToggle) {
  AppDarkModeToggle = appDarkModeToggle ? withInstall(appDarkModeToggle) : '';
}
export { AppLogo, AppProvider, AppSearch, AppLocalePicker, AppDarkModeToggle };
